import React from 'react';
import { Box } from '@mui/material';
import Hyperspeed from './Hyperspeed';
import { hyperspeedPresets } from './hyperspeedPresets';

const HyperspeedBg = ({ preset = 'two' }) => {
  const effectOptions = hyperspeedPresets[preset] || hyperspeedPresets.one;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
      }}
    >
      <Hyperspeed effectOptions={effectOptions} />
    </Box>
  );
};

export default HyperspeedBg;
